import { Component, NgZone, OnInit } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { GigyaService } from '../../../services/gigya.service';
import { InputComponent } from '../../../shared/input/input.component';
import { ButtonComponent } from '../../../shared/button/button.component';
import { SpinnerComponent } from '../../../shared/icons/spinner/spinner.component';
import { MfaService } from '../../../services/mfa.service';
import { WarningIconComponent } from '../../../shared/icons/warning/warning.component';

@Component({
  selector: 'app-mfa-email',
  standalone: true,
  imports: [TranslatePipe, RouterLink, ReactiveFormsModule, InputComponent, ButtonComponent, SpinnerComponent, WarningIconComponent],
  templateUrl: './mfa-email.component.html',
  styleUrl: './mfa-email.component.css'
})
export class MfaEmailComponent implements OnInit {

  public expired = false;
  public failed = false
  public loading = false;
  public resendLoading = false;

  public form: FormGroup = new FormGroup({
    code: new FormControl(""),
    remember: new FormControl(false)
  })

  constructor(
    private router: Router,
    public mfaService: MfaService
  ) { }

  public ngOnInit(): void {
    this.mfaService.sendEmailCode();
  }

  public async onSubmit(): Promise<void> {
    this.loading = true;

    const res = await this.mfaService.submitEmailCode(this.form.value.code, this.form.value.remember);
    if (res.errorCode !== 0) {
      console.warn("MFA email code submission failed", res);
      return
    }
  }

  public async resend(): Promise<void> {
    this.resendLoading = true;
    const res = await this.mfaService.sendEmailCode();
    if (res.errorCode === 400006) {
      this.expired = true;
    }
    this.resendLoading = false;
  }
}
